import Ajax from '../ajax/ajax';
import EventBus from '../helper/event.bus';
import { qarQuartersEnum } from '../helper/constants';
import { observable, action, decorate } from 'mobx';
import { eventBusMessages, eventTypesForBus } from '../helper/enums';
import Helper from "../helper/helper";
import api from 'src/utils/api';

export class QARStore {
    constructor(rootStore) {
        this.rootStore = rootStore;
    }

    lastNotificationDate = "";
    creationDate = "";
    isActionTaken = false;
    showLoadingSpinner = false;
    shouldSaveQAR = false;
    managerSystems = [];
    managerEmployeesForQar = [];
    revertToInitialState = false;
    delegatedEmployees = [];
    currentlyReviewedSystem;
    currentlyReviewedAccount;
    currentlyReviewedEmployee;
    currentlyReviewedRole;
    currentlyReviewedPGs = [];
    myManagers = [];
    allSnpManagers = [];
    allActiveSnpEmployees = [];
    allManagers = [];
    chameleonAdminEmployeeReviews = [];
    validationErrors = [];
    isEmployeeContentModalOpened = false;
    isRoleContentModalOpened = false;
    systemsForReview = [];
    currentlyReviewedSystemForReview;
    currentlySelectedAccountForReview;
    managersByAccount;
    currentlySelectedManager;
    isCommentSectionOpened = false;
    isReviewsHistoryOpened = false;
    currenlySelectedCommentSection;
    reviewHistory = [];
    isCommentPopupOpened = false;
    isCommentFormOpened = false;
    employeesByManagerReview;
    renderLoadingSystemsSpinner = false;
    renderLoadingEmployeesSpinner = false;
    renderSubmitReviewSpinner = false;
    employeesByAccount;
    isEmployeesByAccountOpened = false;
    groupsByRole;
    findingsByAccount;
    delegatedEmployeesByAccount;
    isManagerReviewAdminCompleted = false;
    currentQuarter;
    currentYear;
    allDataCenters = [];
    isManagerReviewsCompleted = false;
    unmatchedAccounts = [];
    snpUnmatchedAccounts = [];
    complianceReviews = [];
    currentComplianceReviewId;
    manualDataForPreview;
    selectedAccountType;
    permissionsForRole = [];

    chameleonGroups = [
        {
            title: 'Chameleon Europe',
            corporateGroups: []
        },
        {
            title: 'Chameleon US',
            corporateGroups: []
        },
        {
            title: 'Chameleon Others',
            corporateGroups: []
        },
    ];

    dueDate;
    totalManagerReviews;
    completedManagerReviews;

    setLastNotificationDate = (val) => this.lastNotificationDate = val;

    setRevertToInitialState = (val) => this.revertToInitialState = val;

    setIsActionTaken = (val) => this.isActionTaken = val;

    setShouldSaveQAR = (val) => this.shouldSaveQAR = val;

    setDelegatedEmployees = (val) => this.delegatedEmployees = val;

    setChameleonAdmins = (val) => this.chameleonAdminEmployeeReviews = val;

    setIsManagerReviewAdminCompleted = (val) => this.isManagerReviewAdminCompleted = val;

    getManagerSystems = (managerId) => Ajax.getManagerSystems(managerId, this.getManagerSystemsSuccess, this.getManagerSystemsError);

    getManagerEmployeesForQar = (managerId) => Ajax.getManagerEmployeesForQar(managerId, this.getManagerEmployeesForQarSuccess, this.getManagerEmployeesForQarError);

    getMyManagers = (managerId) => Ajax.getMyManagers(managerId, this.getMyManagersSuccess, this.getMyManagersError);

    getAllSnpManagers = (currentComplianceReviewId) => Ajax.getAllSnpManagers(currentComplianceReviewId, this.getAllSnpManagersSuccess, this.getAllSnpManagersError);

    getAllActiveSnpEmployees = (currentComplianceReviewId) => Ajax.getAllActiveSnpEmployees(currentComplianceReviewId, this.getAllActiveSnpEmployeesSuccess, this.getAllActiveSnpEmployeesError);

    getAllManagers = () => Ajax.getAllManagers(this.getAllManagersSuccess, this.getAllManagersError);

    saveManagerReview = (data) => Ajax.saveManagerReview(data, this.saveManagerReviewSuccess, this.saveManagerReviewError);

    editManagerReview = (data) => Ajax.editManagerReview(data, this.saveManagerReviewSuccess, this.saveManagerReviewError);

    getAllSystemsForReview = (complianceReviewId) => {
        this.rootStore.qarStore.showLoadingSpinner = true;
        Ajax.getAllSystemsForReview(complianceReviewId, this.getAllSystemsForReviewSuccess, this.getAllSystemsForReviewError);
    }

    sendSOXEmails = (quarter, year, currentUserID) => {

        let data = {
            quarter: qarQuartersEnum[quarter],
            quarterYear: parseInt(year),
            initiatorId: currentUserID
        }

        this.showLoadingSpinner = true;
        Ajax.sendSOXEmails(data, this.onSendEmailsSuccess, this.onSendEmailsError);
    }

    getAllManagersByAccountId = (accountId, complianceReviewId) => {
        this.rootStore.qarStore.showLoadingSpinner = true;
        Ajax.getAllManagersByAccountId(accountId, complianceReviewId, this.getAllManagersByAccountIdSuccess, this.getAllManagersByAccountIdError);
    }

    getEmployeesByManagerReviewId = (reviewId, accountId, complianceReviewId) => Ajax.getEmployeesByManagerReviewId(reviewId, accountId, complianceReviewId, this.getEmployeesByManagerReviewIdSuccess, this.getEmployeesByManagerReviewIdError);

    saveSoxComment = (data) => Ajax.saveSoxComment(data, this.saveCommentSuccess, this.saveCommentError);

    getAllEmployeesByAccountId = (accountId, complianceReviewId) => Ajax.getAllEmployeesByAccountId(accountId, complianceReviewId, this.getAllEmployeesByAccountIdSuccess, this.getAllEmployeesByAccountIdError);

    getGroupsByRoleAndAccount = (roleId, accountId) => Ajax.getGroupsByRoleAndAccount(roleId, accountId, this.getGroupsByRoleAndAccountSuccess, this.getGroupsByRoleAndAccountError);

    getAllFindingsByAccountId = (accountId, complianceReviewId) => Ajax.getAllFindingsByAccountId(accountId, complianceReviewId, this.getAllFindingsByAccountIdSuccess, this.getAllFindingsByAccountIdError);

    getAllDelegatedEmployeesByAccountId = (accountId, complianceReviewId) => Ajax.getAllDelegatedEmployeesByAccountId(accountId, complianceReviewId, this.getAllDelegatedEmployeesByAccountIdSuccess, this.getAllDelegatedEmployeesByAccountIdError);

    getAllDataCenters = () => Ajax.getAllDataCenters(this.getAllDataCentersSuccess, this.getAllDataCentersError);

    getManagerSystemsSuccess = (response) => {
        this.managerSystems = response.data;
    }

    getManagerSystemsError = (err) => {
        console.log(err);
    }

    getManagerEmployeesForQarSuccess = (response) => {
        this.setShouldSaveQAR(!response.data.employees.flatMap(x => x.accounts).some(x => x.action.name !== 0));
        this.setDelegatedEmployees(response.data.employees.flatMap(x => x.accounts).filter(x => x.action.delegatedTo));
        this.setIsManagerReviewAdminCompleted(response.data.isManagerReviewAdminCompleted);
        response.data.employees.forEach(x => x.accounts.sort((a, b) => a.systemName.localeCompare(b.systemName)))
        this.managerEmployeesForQar = response.data.employees;
    }

    getManagerEmployeesForQarError = (err) => {
        console.log(err);
    }

    getMyManagersSuccess = (response) => {
        this.myManagers = response.data;
    }

    getMyManagersError = (err) => {
        console.log(err);
    }

    getAllSnpManagersSuccess = (response) => {
        this.allSnpManagers = response.data;
    }

    getAllSnpManagersError = (err) => {
        console.log(err);
    }

    getAllActiveSnpEmployeesSuccess = (response) => {
        this.allActiveSnpEmployees = response.data;
    }

    getAllActiveSnpEmployeesError = (err) => {
        console.log(err);
    }

    getAllManagersSuccess = (response) => {
        this.allManagers = response.data;
    }

    getAllManagersError = (err) => {
        console.log(err);
    }

    saveManagerReviewSuccess = () => {
        EventBus.publish(eventTypesForBus.saveReviewSuccess, eventBusMessages.saveReviewSuccess);

        this.validationErrors = [];
    }

    saveManagerReviewError = (validationErrors) => {
        EventBus.publish(eventTypesForBus.saveReviewError, eventBusMessages.saveReviewError);

        this.validationErrors = validationErrors;
    }

    getAllSystemsForReviewSuccess = (response) => {
        this.systemsForReview = response.data.soxSystemReviews;
        this.currentQuarter = response.data.currentQuarter;
        this.currentYear = response.data.currentYear;
        this.isManagerReviewsCompleted = response.data.isManagerReviewsCompleted;

        this.dueDate = response.data.dueDate;
        this.totalManagerReviews = response.data.totalManagerReviews;
        this.completedManagerReviews = response.data.completedManagerReviews;

        let lastNotificationDate = response.data.lastNotificationDate;

        if (lastNotificationDate !== undefined) {
            this.setLastNotificationDate(lastNotificationDate);
        }

        this.creationDate = response.data.creationDate;
        this.currentComplianceReviewId = response.data.complianceReviewId;
        this.rootStore.qarStore.showLoadingSpinner = false;
    }

    getAllSystemsForReviewError = (err) => {
        console.log(err);
        this.rootStore.qarStore.showLoadingSpinner = false;
    }
    getAllManagersByAccountIdSuccess = (response) => {
        this.managersByAccount = response.data;
        this.rootStore.qarStore.showLoadingSpinner = false;
    }

    getAllManagersByAccountIdError = (err) => {
        console.log(err);
        this.rootStore.qarStore.showLoadingSpinner = false;
    }

    getEmployeesByManagerReviewIdSuccess = (response) => {
        this.employeesByManagerReview = response.data;
    }

    getEmployeesByManagerReviewIdError = (err) => {
        console.log(err);
    }

    saveCommentSuccess = () => {
        this.getAllManagersByAccountId(this.currentlySelectedAccountForReview.id, this.currentComplianceReviewId);
        EventBus.publish(eventTypesForBus.saveCommentSuccess, eventBusMessages.saveCommentSuccess);
    }

    saveCommentError = () => {
        EventBus.publish(eventTypesForBus.saveCommentError, eventBusMessages.saveReviewError)
    }

    releaseForFurtherUse = () => {
        this.setIsActionTaken(false);
        this.showLoadingSpinner = false;
    }

    onSendEmailsSuccess = (response) => {
        this.releaseForFurtherUse();
        if(response.data.isSuccessful === false){
            EventBus.publish(eventTypesForBus.sendEmailsError, response.data.errorMessages.toString())
        }
        else {
            EventBus.publish(eventTypesForBus.sendEmailsSuccess, eventBusMessages.sendEmailsSuccess)
        }
    }

    onSendEmailsError = () => {
        this.releaseForFurtherUse();
        EventBus.publish(eventTypesForBus.sendEmailsError, eventBusMessages.sendEmailsError)
    }

    initQarForm = () => {
        this.currentlyReviewedSystem = undefined;
        this.currentlyReviewedAccount = undefined;
        this.setRevertToInitialState(!this.revertToInitialState);
        this.validationErrors = [];
    }

    getAllEmployeesByAccountIdSuccess = (response) => {
        this.employeesByAccount = response.data;
    }

    getAllEmployeesByAccountIdError = (err) => {
        console.log(err);
    }

    getGroupsByRoleAndAccountSuccess = (response) => {
        this.groupsByRole = response.data;
    }

    getGroupsByRoleAndAccountError = (err) => {
        console.log(err);
    }

    getChameleonAdminsEmployeeReviewsPerAccount = (accountId, complianceReviewId) => Ajax.getChameleonAdminsEmployeeReviewsPerAccount(accountId, complianceReviewId, this.getChameleonAdminsEmployeeReviewsPerAccountHandleSuccess, this.getChameleonAdminsEmployeeReviewsPerAccountHandelError);

    getChameleonAdminsEmployeeReviewsPerAccountHandleSuccess = (response) => {
        this.setChameleonAdmins(response.data);
    };

    getChameleonAdminsEmployeeReviewsPerAccountHandelError = (error) => {
        console.log(error);
    }

    getAllFindingsByAccountIdSuccess = (response) => {
        this.findingsByAccount = response.data;
    }

    getAllDelegatedEmployeesByAccountIdSuccess = (response) => {
        this.delegatedEmployeesByAccount = response.data;
    }

    getUnmatchedAccounts = (snpAccountId) => Ajax.getUnmatchedAccounts(snpAccountId, this.getUnmatchedAccountsSuccess, this.getUnmatchedAccountsError);

    setUnmatchedAccounts = (val) => this.unmatchedAccounts = val

    getUnmatchedAccountsSuccess = (response) => {
        this.setUnmatchedAccounts(response.data);
    };

    getUnmatchedAccountsError = (error) => {
        console.log(error);
    }

    getAllUnmatchedAccounts = () => Ajax.getAllUnmatchedAccounts(this.getAllUnmatchedAccountsSuccess, this.getAllUnmatchedAccountsError);

    getAllUnmatchedAccountsSuccess = (response) => {
        this.setUnmatchedAccounts(response.data);
    };

    getAllUnmatchedAccountsError = (error) => {
        console.log(error);
    }

    getSnpUnmatchedAccounts = (snpAccountId, complianceReviewId) => Ajax.getSnpUnmatchedAccounts(snpAccountId, complianceReviewId, this.getSnpUnmatchedAccountsSuccess, this.getSnpUnmatchedAccountsError);

    setSnpUnmatchedAccounts = (val) => this.snpUnmatchedAccounts = val

    getSnpUnmatchedAccountsSuccess = (response) => {
        this.setSnpUnmatchedAccounts(response.data);
    };

    getSnpUnmatchedAccountsError = (error) => {
        console.log(error);
    }

    setResponsibleManager = (data) => Ajax.setResponsibleManager(data, this.setResponsibleManagerSuccess, this.setResponsibleManagerError);

    setResponsibleManagerSuccess = () => {
        EventBus.publish(eventTypesForBus.setResponsibleManagerSuccess, eventBusMessages.setResponsibleManagerSuccess);
    }

    setResponsibleManagerError = () => {
        EventBus.publish(eventTypesForBus.setResponsibleManagerError, eventBusMessages.setResponsibleManagerError)
    }

    getAllFindingsByAccountIdError = (error) => {
        console.log(error);
    }

    getAllDelegatedEmployeesByAccountIdError = (error) => {
        console.log(error);
    }

    setManagerReviewsAsCompleted = (quarter, year, accountId) => {
        this.showLoadingSpinner = true;
        Ajax.setManagerReviewsAsCompleted(quarter, year, accountId, this.onSetManagerReviewsAsCompletedSuccess, this.onSetManagerReviewsAsCompletedError);
    }

    onSetManagerReviewsAsCompletedSuccess = () => {
        this.releaseForFurtherUse();
        this.completedManagerReviews = true;
        EventBus.publish(eventTypesForBus.setManagerReviewsAsCompletedSuccess, eventBusMessages.setManagerReviewsAsCompletedSuccess)
    }

    onSetManagerReviewsAsCompletedError = () => {
        this.releaseForFurtherUse();
        EventBus.publish(eventTypesForBus.setManagerReviewsAsCompletedError, eventBusMessages.setManagerReviewsAsCompletedError)
    }

    getAllDataCentersSuccess = (response) => {
        this.allDataCenters = response.data;
    }

    getAllDataCentersError = (err) => {
        console.log(err);
    }

    delegateEmployeesFromAdminPanel = (data) => Ajax.delegateEmployeesFromAdminPanel(data, this.delegateEmployeesFromAdminPanelSuccess, this.delegateEmployeesFromAdminPanelError);

    delegateEmployeesFromAdminPanelSuccess = (response) => this.getEmployeesByManagerReviewId(this.currentlySelectedManager.managerReviewID, this.currentlySelectedAccountForReview.id, this.currentComplianceReviewId);

    delegateEmployeesFromAdminPanelError = (error) => console.log(error);

    getReviewHistoryByManagerReviewId = (managerReviewId, accountId) => Ajax.getReviewHistoryByManagerReviewId(managerReviewId, accountId, this.getReviewHistoryByManagerIdSuccess, this.getReviewHistoryByManagerIdError);

    getReviewHistoryByManagerIdSuccess = (response) => {
        this.reviewHistory = response.data;
    }

    getReviewHistoryByManagerIdError = (err) => {
        console.log(err);
    }

    getComplianceReviews = () => {
        this.rootStore.qarStore.showLoadingSpinner = true;
        Ajax.getComplianceReviews(this.getComplianceReviewsSuccess, this.getComplianceReviewsError);
    }

    getComplianceReviewsSuccess = (response) => {
        this.complianceReviews = response.data;
    }

    getComplianceReviewsError = (err) => {
        console.log(err);
    }

    setAccountGroups = (account) => {
        console.log("Setting account groups for account", account);

      switch (account.name) {
        case 'sbtech': {
          let checkOslmainAccount = this.chameleonGroups[0].corporateGroups.find(x => { return x.name === 'EU SBTech' });
          if (!checkOslmainAccount) {
            account.name = 'EU SBTech';
            this.chameleonGroups[0].corporateGroups.push(account);
          }
          break;
        }
        case 'sbt': {
          let checkOslmainAccount = this.chameleonGroups[0].corporateGroups.find(x => { return x.name === 'EU SBT' });
          if (!checkOslmainAccount) {
            account.name = 'EU SBT';
            this.chameleonGroups[0].corporateGroups.push(account);
          }
          break;
        }
        case 'sbtms': {
          let checkOslmainAccount = this.chameleonGroups[0].corporateGroups.find(x => { return x.name === 'EU SBTMS' });
          if (!checkOslmainAccount) {
            account.name = 'EU SBTMS';
            this.chameleonGroups[0].corporateGroups.push(account);
          }
          break;
        }
        case 'sport': {
          let checkOslmainAccount = this.chameleonGroups[0].corporateGroups.find(x => { return x.name === 'EU Sport' });
          if (!checkOslmainAccount) {
            account.name = 'EU Sport';
            this.chameleonGroups[0].corporateGroups.push(account);
          }
          break;
        }
        // case 'oslmain': {
        //   let checkOslmainAccount = this.chameleonGroups[1].corporateGroups.find(x => { return x.name === 'OSL Main' });
        //   if (!checkOslmainAccount) {
        //     account.name = 'OSL Main';
        //     this.chameleonGroups[1].corporateGroups.push(account);
        //   }
        //   break;
        // }
        // case 'oslusa': {
        //   let checkOslmainAccount = this.chameleonGroups[1].corporateGroups.find(x => { return x.name === 'OSL USA' });
        //   if (!checkOslmainAccount) {
        //     account.name = 'OSL USA';
        //     this.chameleonGroups[1].corporateGroups.push(account);
        //   }
        //   break;
        // }
        // case 'sportosl': {
        //   let checkOslmainAccount = this.chameleonGroups[1].corporateGroups.find(x => { return x.name === 'SportOSL' });
        //   if (!checkOslmainAccount) {
        //     account.name = 'SportOSL';
        //     this.chameleonGroups[1].corporateGroups.push(account);
        //   }
        //   break;
        // }
        case 'Mainus': {
          let checkOslmainAccount = this.chameleonGroups[1].corporateGroups.find(x => { return x.name === 'MainUS' });
          if (!checkOslmainAccount) {
            account.name = 'MainUS';
            this.chameleonGroups[1].corporateGroups.push(account);
          }
          break;
        }
        case 'sportus': {
          let checkOslmainAccount = this.chameleonGroups[1].corporateGroups.find(x => { return x.name === 'Sport US' });
          if (!checkOslmainAccount) {
            account.name = 'Sport US';
            this.chameleonGroups[1].corporateGroups.push(account);
          }
          break;
        }
        case 'us': {
          let checkOslmainAccount = this.chameleonGroups[1].corporateGroups.find(x => { return x.name === 'US' });
          if (!checkOslmainAccount) {
            account.name = 'US';
            this.chameleonGroups[1].corporateGroups.push(account);
          }
          break;
        }
        default: {
          let checkOslmainAccount = this.chameleonGroups[2].corporateGroups.find(x => { return x.name === account.name });
          let checkEuropeAccounts = this.chameleonGroups[0].corporateGroups.find(x => { return x.name === account.name });
          //let checkOregonAccounts = this.chameleonGroups[1].corporateGroups.find(x => { return x.name === account.name });
          let checkUsAccounts = this.chameleonGroups[1].corporateGroups.find(x => { return x.name === account.name });
          if (!checkOslmainAccount && !checkEuropeAccounts && !checkUsAccounts) {
            this.chameleonGroups[2].corporateGroups.push(account);
          }
        }
      }

      console.log("Chameleon groups set: ", this.chameleonGroups);
    }

    clearAccountGroups = () => {
        this.chameleonGroups.forEach(x => {
            x.corporateGroups = []
        });
    }

    async uploadManualDataFile(data) {
        this.showLoadingSpinner = true;

        const uploadManualDataFileResponse = await api.post(`QAR/UploadFile`, data, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            timeout: 30 * 60E3, // wait 30 minutes, go drink coffee
        })

        if(!api.responseOk(uploadManualDataFileResponse) || !uploadManualDataFileResponse.data.isSuccessful) {
            this.showLoadingSpinner = false;
            const errorMessages = uploadManualDataFileResponse.data.errorMessages;
            const formattedErrorMessages = errorMessages.map((message) => <p>{message}</p>);
            const modalContent = (
            <>
                <h2 style={{ textAlign: 'center', color: 'red' }}>Validation Errors</h2>
                {formattedErrorMessages}
            </>);

            this.rootStore.uiStateStore.setModalContent(modalContent);
            this.rootStore.uiStateStore.setModalOpen(true);
            return;
        }

        this.showLoadingSpinner = false;
            EventBus.publish(eventTypesForBus.uploadManualDataFileSuccess, eventBusMessages.uploadManualDataFileSuccess);
            this.manualDataForPreview = this.getManualDataForPreview();
    }

    async getManualDataForPreview() {
        const manualDataForPreviewResponse = await api.get(`QAR/GetManualDataForPreview`);

        if(!api.responseOk(manualDataForPreviewResponse)) {
            return;
        }

        this.manualDataForPreview = manualDataForPreviewResponse.data;
    }

    async getPermissionsForRoleAsync(roleId) {

        this.rolePermissionInfo = undefined;

        const responseRolePermissionInfo = await api.get(`pg/GetNonSnpPermissionsByRoleId?roleId=${roleId}`);
        
        if(!api.responseOk(responseRolePermissionInfo)) {
            return;
        }

        this.permissionsForRole = responseRolePermissionInfo.data;
    }

    async MarkSystemsAsReviewed(){
        const response = await api.post(`QAR/MarkSystemsAsReviewed`)
        if(!api.responseOk(response)) {
            EventBus.publish(eventTypesForBus.markSystemsAsReviewedError, eventBusMessages.markSystemsAsReviewedError)
            return;
        }
        
        EventBus.publish(eventTypesForBus.markSystemsAsReviewedSuccess, eventBusMessages.markSystemsAsReviewedSuccess);
    }
}

decorate(QARStore, {
    lastNotificationDate: observable,
    creationDate: observable,
    revertToInitialState: observable,
    chameleonAdminEmployeeReviews: observable,
    isActionTaken: observable,
    managerSystems: observable,
    managerEmployeesForQar: observable,
    currentlyReviewedSystem: observable,
    currentlyReviewedAccount: observable,
    currentlyReviewedEmployee: observable,
    currentlyReviewedRole: observable,
    currentlyReviewedPGs: observable,
    myManagers: observable,
    allSnpManagers: observable,
    allActiveSnpEmployees: observable,
    allManagers: observable,
    delegatedEmployees: observable,
    validationErrors: observable,
    isEmployeeContentModalOpened: observable,
    isRoleContentModalOpened: observable,
    renderLoadingSystemsSpinner: observable,
    renderLoadingEmployeesSpinner: observable,
    renderSubmitReviewSpinner: observable,
    shouldSaveQAR: observable,
    isManagerReviewAdminCompleted: observable,
    setLastNotificationDate: action,
    setIsActionTaken: action,
    setDelegatedEmployees: action,
    setShouldSaveQAR: action,
    getManagerSystems: action,
    getManagerEmployeesForQar: action,
    saveManagerReview: action,
    saveManagerReviewSuccess: action,
    saveManagerReviewError: action,
    getAllSystemsForReview: action,
    systemsForReview: observable,
    currentlyReviewedSystemForReview: observable,
    sendEmails: action,
    showLoadingSpinner: observable,
    currentlySelectedAccountForReview: observable,
    getAllManagersByAccountId: action,
    managersByAccount: observable,
    currentlySelectedManager: observable,
    isCommentSectionOpened: observable,
    currenlySelectedCommentSection: observable,
    reviewHistory: observable,
    isCommentPopupOpened: observable,
    isCommentFormOpened: observable,
    employeesByManagerReview: observable,
    getEmployeesByManagerReviewId: action,
    saveComment: action,
    saveCommentSuccess: action,
    saveCommentError: action,
    saveFeedback: action,
    saveFeedbackError: action,
    editManagerReview: action,
    initQarForm: action,
    getAllEmployeesByAccountId: action,
    employeesByAccount: observable,
    isEmployeesByAccountOpened: observable,
    getGroupsByRoleAndAccountError: action,
    groupsByRole: observable,
    getAllFindingsByAccountId: action,
    findingsByAccount: observable,
    getAllDelegatedEmployeesByAccountId: action,
    delegatedEmployeesByAccount: observable,
    currentQuarter: observable,
    currentYear: observable,
    allDataCenters: observable,
    isManagerReviewsCompleted: observable,
    unmatchedAccounts: observable,
    snpUnmatchedAccounts: observable,
    isReviewsHistoryOpened: observable,
    complianceReviews: observable,
    currentComplianceReviewId: observable,
    
    dueDate: observable,
    totalManagerReviews: observable,
    completedManagerReviews: observable,
    
    chameleonGroups: observable,

    manualDataForPreview: observable,
    selectedAccountType: observable,
    permissionsForRole: observable,
})
